var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{staticStyle:{"cursor":"pointer"},attrs:{"aspect-ratio":"1","lazy-src":this.image64,"src":this.image64}})}
var staticRenderFns = []

export { render, staticRenderFns }